import React, { Suspense, lazy } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Loader from './Loader';

const Sidebar = lazy(() => import('../layout/sidebar'));
const Header = lazy(() => import('../layout/Header'));

const PrivateRoutes = () => {
  const token = localStorage.getItem('access_token');
  // return token !== null && token !== undefined && token !== '' ? (
  // var token = true;
  return token !== null && token !== undefined && token !== '' ? (
    <Suspense fallback={<Loader fullScreen={true} />}>
      <div className="d-flex">
        <Sidebar />
        <div className="main-content-container">
          <Header />
          <article className="content-container">
            <Outlet />
          </article>
        </div>
      </div>
    </Suspense>
  ) : (
    <Navigate replace to="/login" />
  );
};

export default PrivateRoutes;
